import RedemptionForm, { RedemptionFormDispatchProps, RedemptionFormOwnProps, RedemptionFormStateProps } from 'components/features/pfm/RedemptionForm/RedemptionForm'
import { MapDispatchToPropsFunction } from 'react-redux'
import { focus, getFormSubmitErrors, getFormValues } from 'redux-form'
import { createSelector } from 'reselect'
import { FORM_REDEMPTION } from 'constants/forms'
import { setRedemptionStepNumberCreator } from 'actions/bountyActions'
import { minRedemptionAmountSelector, redemptionAccountSelector, rewardBalanceSelector } from 'selectors/bountySelectors'
import { connectLoadable } from 'helpers/loadableHelpers'
import { redemptionAccountGuard } from 'guards/bountyGuards'
import { RedemptionFormValues } from 'interfaces/bounty'

const DEFAULT_FORM_VALUES: RedemptionFormValues = {
  amount: 0,
  bank_account_type: 'checking',
  routing_number: '',
  account_number: '',
  remember: false,
  name: '',
}

const mapStateToProps = createSelector(
  rewardBalanceSelector,
  minRedemptionAmountSelector,
  redemptionAccountSelector,
  getFormValues<RedemptionFormValues>(FORM_REDEMPTION),
  getFormSubmitErrors<RedemptionFormValues>(FORM_REDEMPTION),
  (rewardBalance, minRedemptionAmount, redemptionAccount, formValues, submitErrors): RedemptionFormStateProps => ({
    formValues,
    initialValues: {
      ...DEFAULT_FORM_VALUES,
      ...redemptionAccount,
      remember: Boolean(redemptionAccount),
      amount: rewardBalance || 0,
    },
    submitErrors,
    rewardBalance: rewardBalance || 0,
    minRedemptionAmount,
  })
)

const mapDispatchToProps: MapDispatchToPropsFunction<RedemptionFormDispatchProps, RedemptionFormOwnProps> = (dispatch, ownProps) => {
  return ({
    onStepChange: (nextStep) => {
      dispatch(setRedemptionStepNumberCreator(nextStep))
      ownProps.onStepChange(nextStep)
    },
    onRememberChange: (value: boolean) => {
      if (value) {
        dispatch(focus(FORM_REDEMPTION, 'name'))
      }
    },
  })
}

const RedemptionFormContainer = connectLoadable<
  RedemptionFormStateProps,
  RedemptionFormDispatchProps,
  RedemptionFormOwnProps
>([redemptionAccountGuard])(mapStateToProps, mapDispatchToProps)(RedemptionForm)

export default RedemptionFormContainer
